import CookieSetter from 'components/cookie-setter'
import PseudolinkLoader from 'components/pseudolink-loader'
import PseudolinkRedirect from 'components/pseudolink-redirect'
import XTab from 'components/x-tab'
import AvatarWrapper from 'components/avatar-wrapper'
import ClassicIndex from 'components/classic-index'
import DialogModal from 'components/dialog-modal'
import CkeditorEveryone from 'components/ckeditor-everyone'
import ProfileAgent from 'components/profile-agent'
import EmergiaTooltip from 'components/emergia-tooltip'
import PhoneWithPrefix from 'components/phone-with-prefix'
import LazyloadBgimage from 'components/lazyload-bgimage'
import LazyloadImage from 'components/lazyload-image'
import LazyloadIframe from 'components/lazyload-iframe'
import Dropdownable from 'components/dropdownable'
import CustomCarousel from 'components/carousel'

customElements.define('cookie-setter', CookieSetter)
customElements.define('pseudolink-loader', PseudolinkLoader)
customElements.define('pseudolink-redirect', PseudolinkRedirect)
customElements.define('x-tab', XTab, { extends: 'span' })
customElements.define('avatar-wrapper', AvatarWrapper)
customElements.define('classic-index', ClassicIndex)
customElements.define('dialog-modal', DialogModal)
customElements.define('ckeditor-everyone', CkeditorEveryone, { extends: 'textarea' })
customElements.define('profile-agent', ProfileAgent)
customElements.define('emergia-tooltip', EmergiaTooltip)
customElements.define('phone-with-prefix', PhoneWithPrefix)
customElements.define('lazyload-bgimage', LazyloadBgimage, { extends: 'div' })
customElements.define('lazyload-image', LazyloadImage, { extends: 'img' })
customElements.define('lazyload-iframe', LazyloadIframe, { extends: 'iframe' })
customElements.define('dropdown-able', Dropdownable)
customElements.define('c-carousel', CustomCarousel)
